import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import AISolutions from "../pages/AISolutions";
import Products from "../pages/Products";
import Portfolio from "../pages/Portfolio";
import Technologies from "../pages/Technologies";
import Careers from "../pages/Careers";
import Contact from "../pages/Contact";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/ai-solutions" element={<AISolutions />} />
      <Route path="/products" element={<Products />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/technologies" element={<Technologies />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
}
